<div class="my-new-chat">
  <input type="file" #fileUpload style="display: none" accept="image/*" (change)="onFileChanged($event)" />
  <!-- Header Section -->
  @if (currentlyTalkingToId || (chatConfig?.isTypesGroupMode && (forCategoryId || forTypeId))) {
  <div class="room">
    <div class="room__header">
      <div class="back" (click)="goBacktoChatList()" *ngIf="allowBackButton && !chatConfig.lockChat">
        <i class="fa fa-arrow-left"></i>
      </div>
      <span class="w-100 d-flex flex-column">
        <span class="w-100 d-flex justify-content-between">
          <span>
            <!-- <span style="color: var(--secondary)"> <i *ngIf="isGroupChat" class="fa-solid fa-users mr-2"></i> {{ currentlyTalkingToName || "Unknown" }} </span> -->

            @if (hasCurrentBlockedMe) {
            <span style="font-size: 12px">Last seen unknown</span>
            } @else { @if (!isCurrentTyping) { @if (isCurrentOnline || isCurrentBiz || isSellerAIModeOn) {
            <span style="color: purple; font-size: 12px"> Online </span>
            } @else {
            <span style="font-size: 12px">{{ currentLastSeenTime }}</span>
            } } @else {
            <span class="typing-indicator" style="text-transform: none; color: black; font-weight: bold"></span>
            } }
            <button class="ml-2" *ngIf="whatsAppNumber" (click)="openChatsWhatsApp()" style="background: transparent; border: 0; color: lightgreen"><i class="fa-brands fa-whatsapp"></i></button>
            <button class="ml-2" *ngIf="!isBiz && currentlyTalkingToId != 'ai' && aiChatAllowe && !chatConfig.lockChat" style="background: transparent; border: 0px" [style.color]="isSellerAIModeOn ? 'green' : 'grey'" (click)="toggleAIChatMode()"><i class="fa-solid fa-robot"></i></button>
          </span>

          <div ngbDropdown container="body" class="d-inline-block right mr-3" style="background-color: transparent; border: 0" *ngIf="!chatConfig.lockChat">
            <span ngbDropdownToggle id="dropdownMenuButton" class="fa fa-ellipsis"></span>
            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item" *ngIf="isCurrentchatBlocked" (click)="unblockCurrrent()" aria-label="Unblock User" style="background: transparent; border: 0; color: purple"><i class="fa-solid fa-user-check"></i> Unblock User</button>
              <button class="dropdown-item" *ngIf="!isCurrentchatBlocked" (click)="blockCurrrent()" aria-label="Block User" style="background: transparent; border: 0; color: deeppink"><i class="fa-solid fa-ban"></i> Block User</button>

              <button class="dropdown-item" *ngIf="chatMode === 'Archive'" (click)="removeChatFromArchive()" aria-label="Remove Chat From Archive" style="background: transparent; border: 0; color: purple"><i class="fa-solid fa-user-check"></i> Remove Chat From Archive</button>
              <button class="dropdown-item" *ngIf="chatMode === 'Main'" (click)="addChatToArchive()" aria-label="Add Chat To Archive" style="background: transparent; border: 0; color: deeppink"><i class="fa-solid fa-book"></i> Add Chat To Archive</button>
              <button class="dropdown-item" *ngIf="whatsAppNumber" (click)="openChatsWhatsApp()" aria-label="Open chat's Whatsapp" style="background: transparent; border: 0; color: deeppink"><i class="fa-brands fa-whatsapp"></i> Open chat's WhatsApp</button>
            </div>
          </div>
        </span>

        <span *ngIf="currentProductImage && currentProductTitle" class="d-flex justify-content-start align-items-center mt-3 font-italic w-100" style="gap: 8px">
          <img loading="lazy" [src]="currentProductImage" style="height: 3.2em; width: 3.2em; border-radius: 20px" />
          <div class="d-flex flex-column justify-content-center">
            <span>
              {{ currentProductTitle }}
            </span>
          </div>
        </span>
        <div *ngIf="isGettingBefore" class="d-flex justify-content-center w-100">
          <span class="font-italic" style="font-weight: bold; font-size: 12px; color: purple"> Loading older Messages...</span>
        </div>
      </span>
    </div>

    <!-- <button (click)="getCurrenChatsMessages()">Refresh</button> -->

    <!-- Chat Messages Section -->
    <!-- <script>
      document.addEventListener("DOMContentLoaded", (_) => {
        const elem = document.querySelector("#msg-scroll");
        console.log("scrolling to bottom");
        element.scrollTop = element.scrollHeight;
      });
    </script> -->
    <div #contextMenu *ngIf="isContextMenuVisible" [style.top.px]="contextMenuY" [style.left.px]="contextMenuX" class="context-menu">
      <button (click)="openReportForm()" style="background-color: transparent; border: 0px"><i class="fa fa-flag"></i> Report Message</button>
    </div>
    <div *ngIf="!initLoaded" style="position: absolute; top: 50%; width: 100%; text-align: center">Loading...</div>
    <div class="room__message" id="msg-scroll" #scrollContainer (scroll)="onMessageScroll(event)" [class.invisible]="!initLoaded">
      <!-- Chat messages go here -->
      <div *ngIf="currentChatMessages.length === 0 && currentlyTalkingToId !== 'ai'" aria-hidden="true" class="message-row right">
        <div class="bubble">
          <div class="bubble-text">Hello! Type something to start the conversation and I'll be right here.</div>
        </div>
        <div class="avatar">
          <img src="assets/images/comic-chat/avatar/6.jpg" alt="" />
        </div>
      </div>
      <div *ngIf="currentChatMessages.length == 0 && currentlyTalkingToId === 'ai'">
        <div style="background-color: white; border: 2px solid purple; border-radius: 10px; padding: 20px; max-width: 400px; font-family: Arial, sans-serif; color: #333; box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2); text-align: center; margin: 20px auto">
          <img class="mb-2" style="max-width: 80%; aspect-ratio: 1/1" src="assets/images/robot-image.webp" />
          <h1 style="font-size: 1.5em; margin: 0; color: purple">Hello 👋, I'm an AI Bot</h1>
          <p style="font-size: 1em; margin-top: 10px">I’m your friendly AI. You can ask me any questions, and I'll do my best to help!</p>
        </div>
      </div>
      <div *ngFor="let message of currentChatMessages; index as i" (contextmenu)="rightClickMessageHandler($event)" [attr.messageId]="message.id" [attr.validContext]="message.from == currentlyTalkingToId && !message['chatAction']" [ngClass]="{}">
        <!-- @if(message['chatAction'] === 'BLOCKED'){ @if(message['from'] == currentlyTalkingToId){
        <span>User has blocked you</span>
        } @else{
        <span>You blocked the user</span>
        } } @else if(message['chatAction'] === 'UNBLOCKED'){ @if(message['from'] == currentlyTalkingToId){
        <span>User has unblocked you</span>
        } @else{
        <span>You have unbloked the user</span>
      -->
        <span *ngIf="dateMarkOf(i) && currentlyTalkingToId != 'ai' && !isSellerAIModeOn" class="d-flex w-100 align-items-center justify-content-center" style="margin: 10px 0px; padding: 10px 0px 0px">
          <span style="height: 1px; background: #000f0f14; width: auto; flex: 1"></span>
          <span style="color: rgb(175, 175, 175); z-index: 1000; overflow-wrap: break-word; position: sticky; top: 0px; font-size: 12px; text-align: center; overflow: hidden; white-space: nowrap; font-weight: 400; align-self: center; display: inline-block; width: auto; padding: 5px 10px">
            <!-- @if ( isDateToday((i))){ Today } @else{ -->
            {{ dateMarkOf(i) }}
            <!-- } -->
          </span>
          <span style="height: 1px; background: #000f0f14; width: auto; flex: 1"></span>
        </span>
        <!-- @if(message['isDate']){
        <span>{{ message["val"] }}</span> -->

        <!-- } @else{ -->
        @if (chatConfig.style == "wizard") {
        <div class="message-row-and-name">
          <div
            class="message-row"
            #bubble
            [ngClass]="{
                right: isRight(message),
                left: isLeft(message),
              }"
          >
            <div class="avatar-col pt-2">
              <span
                class="chat-name"
                [ngClass]="{
                right: isRight(message),}"
                >{{ message["fromName"] ? message["fromName"] : message["tempName"] || "No name" }}</span
              >
              <div class="avatar" aria-hidden="true">
                @if (message.profileCharacterImageFile && !message["tempName"]) {
                <img [src]="imageUrl + message.profileCharacterImageFile" alt="" />
                } @else if (message["tempName"]) {
                <span class="avatar-initial">{{ (message["tempName"] || "U")[0].toUpperCase() }}</span>
                } @else {
                <img [src]="'../../../../assets/images/comic-chat/avatar/6.jpg'" alt="" />
                }
              </div>
            </div>

            <div class="bubble">
              <button (click)="showImage(message['imageContent'])" *ngIf="message['imageContent']" style="border: 0px; background: transparent">
                <img loading="lazy" [src]="message['imageContent']" style="width: 60px; height: 60px" />
              </button>

              <div class="bubble-text">{{ message["textContent"] }}</div>
              <div *ngIf="shouldShowDeleteButton" class="delete-menu-container">
                <button class="delete-btn dropdown-toggle" type="button" (click)="toggleDeleteMenu(message, $event)">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
                <div *ngIf="isDeleteMenuOpen(message)" class="delete-menu-dropdown">
                  <button class="dropdown-item" type="button" (click)="confirmDeleteMessage(message, $event)">
                    <i class="fa fa-trash" style="color: #dc3545"></i>
                    <span>Delete Message</span>
                  </button>
                  <button class="dropdown-item" type="button" (click)="banUserFromMessage(message, $event)">
                    <i class="fa-solid fa-ban" style="color: #dc3545"></i>
                    <span>Ban User</span>
                  </button>
                </div>
              </div>

              <h5 class="d-none" *ngIf="isLeft(message); else rightMessage">{{ message["textContent"] }}</h5>
              <ng-template #rightMessage>
                <h6 class="d-none">{{ message["textContent"] }}</h6>
              </ng-template>
            </div>
          </div>
        </div>
        } @else {
        <span
          [ngClass]="{
                'message-text': true,
                'room__message--right': isRight(message),
                'room__message--left': isLeft(message),
              }"
        >
          <button (click)="showImage(message['imageContent'])" *ngIf="message['imageContent']" style="border: 0px; background: transparent">
            <img loading="lazy" [src]="message['imageContent']" style="width: 60px; height: 60px" />
          </button>

          <span class="h-100 w-100 d-flex flex-column justify-content-around" style="margin-bottom: 3px">
            <div *ngFor="let text of message['textContent']?.split('\n').slice(0, message['textContent'].split('\n').length)">
              <div [innerHTML]="textLink(text)" (click)="handleClickLink($event)"></div>
            </div>
          </span>
          <div *ngIf="shouldShowDeleteButton" class="delete-menu-container">
            <button class="delete-btn dropdown-toggle" type="button" (click)="toggleDeleteMenu(message, $event)">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div *ngIf="isDeleteMenuOpen(message)" class="delete-menu-dropdown">
              <button class="dropdown-item" type="button" (click)="confirmDeleteMessage(message, $event)">
                <i class="fa fa-trash" style="color: #dc3545"></i>
                <span>Delete Message</span>
              </button>
              <button class="dropdown-item" type="button" (click)="banUserFromMessage(message, $event)">
                <i class="fa-solid fa-ban" style="color: #dc3545"></i>
                <span>Ban User</span>
              </button>
            </div>
          </div>
          <span class="message-time">
            {{ getHourAndMinute(message["sendTime"]) }}
          </span>
        </span>
        }

        <!-- } -->
      </div>

      <!-- <div style="height: 39px; width: 200; display: block; background: transparent"></div> -->
    </div>
    <ng-content></ng-content>
    <!-- @if (!isLogin) {
    <div class="room__guest-name">
      @if (!guestName) {
      <form (ngSubmit)="confirmGuestName()" class="guest-name-form" *ngIf="!guestName">
        <label class="guest-name-form__label" for="guestNameInput">Enter your name to continue</label>
        <div class="guest-name-form__controls">
          <input id="guestNameInput" name="guestNameInput" autocomplete="name" class="form-control" [(ngModel)]="guestNameInput" placeholder="Your name" />
          <button type="submit" class="btn btn-primary btn-sm" [disabled]="!guestNameInput?.trim()">Save</button>
        </div>
      </form>
      } @else {
      <div class="guest-name-form__saved">
        <i class="fa fa-user"></i>
        <span
          >Chatting as <strong>{{ guestName }}</strong></span
        >
      </div>
      }
    </div>
    } -->
    <!-- Input Section at the Bottom -->
    <span style="font-size: 12px" class="font-italic" *ngIf="selectedFile">
      <span class="fa fa-image"></span>
      {{ selectedFile.name }}
      <span class="fa fa-x" style="color: rgb(239, 61, 61)" (click)="removeSelectedFiles()"> </span>
    </span>

    <span *ngIf="uploading"> Uploading... </span>
    <div class="room__input" *ngIf="isLogin || guestName">
      <span *ngIf="isCurrentchatBlocked" style="font-weight: bold">User is blocked</span>
      <!-- <span *ngIf="hasCurrentBlockedMe && !isCurrentchatBlocked" style="font-weight: bold">User has blocked you</span> -->
      <textarea #textToSendContainer *ngIf="!isCurrentchatBlocked" [disabled]="isCurrentchatBlocked" [(ngModel)]="textToSend" (keyup)="chatKeyListener($event)" placeholder="Message"></textarea>
      <span (click)="selectImageForSending()" *ngIf="!isCurrentchatBlocked && currentlyTalkingToId !== 'ai'" class="d-flex flex-column justify-content-center align-items-center" style="color: purple">
        <span class="fa fa-image"></span>
      </span>
      <button *ngIf="!isCurrentchatBlocked" (click)="sendMessage()">
        <i class="fa-solid fa-paper-plane"></i>
      </button>
    </div>
  </div>
  } @else {
  <!-- Chat List Section -->
  <!-- <button (click)="getAllChats()">Refresh</button> -->
  <!-- <div class="chat-item">
    <div class="chat-item__img"><span>A</span></div>
    <div class="chat-item__body">
      <div class="user-name">Ahmed Masry</div>
      <div class="details-bottom">
        <div class="last-message">hello world</div>
        <div class="unread-count"> <span>1093</span> </div>
      </div>
    </div>
  </div> -->
  <!-- <div *ngIf="!currentChats.length">No chat available</div> -->
  <div *ngIf="showMainAI" class="chat-item" (click)="setChat('ai') && chatMode == 'Main'">
    <div>
      <div class="chat-item__img">🤖</div>
      <span style="font-size: 0.65rem; font-weight: bold">AI Chat</span>
    </div>
    <div class="chat-item__body">
      <div class="about-chat">
        <div class="user-name">AI CHAT</div>
        <div class="details-bottom" *ngIf="chatMode == 'Main'">
          <div class="last-message" style="max-width: 200px; text-overflow: ellipsis; height: 3.25rem">Start Chatting with our AI</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let chat of currentChats; index as i" class="chat-item" (click)="forTypeId = chat?.type?.id; forCategoryId = chat?.category?.id; currentlyTalkingToId = chat['chatId']; resetChat()">
    <!-- Profile Circle -->
    <div>
      <div class="chat-item__img">
        @if (chat["profileCharacterImageFile"]) {
        <img loading="lazy" [src]="chat['profileCharacterImageFile']" />
        } @else {
        {{ (chat["profileCharacterName"] || "Unnamed")[0] }}
        }
      </div>
      <span style="font-size: 0.65rem; font-weight: bold; max-width: 100%; position: relative">
        <span style="text-overflow: ellipsis">
          {{ chat["profileCharacterName"] || "Unknown" }}
        </span>
        <span style="color: red; font-size: 2.5rem; position: absolute; bottom: 0; right: 0" *ngIf="chat.isLastChatProductDeleted">.</span>
      </span>
    </div>

    <!-- Chat Details -->
    <div class="chat-item__body">
      <div class="about-chat">
        @if (chat.lastMesssageAboutProduct?.name) {
        <div class="user-name">{{ chat.lastMesssageAboutProduct.name }}</div>
        } @else {
        <div class="user-name" style="color: purple">No Product</div>
        }

        <div class="details-bottom" *ngIf="chatMode == 'Main'">
          @if (chat["isLastMessageImageOnly"]) {
          <div class="last-message" style="max-width: 200px; text-overflow: ellipsis; height: 3.25rem">
            Image <ng-container *ngIf="chat.category?.name || chat.type?.name">({{ chat.category?.name ?? chat.type?.name }})</ng-container>
          </div>
          }
          <!-- @else if(chat['chatAction']){ @if(chat['chatAction'] === 'BLOCKED'){ @if(chat['lastMessageFrom'] == chat['chatId'] ){
          <span style="color: purple"></span>
          } @else{
          <span style="color: purple"></span>
          } } @else if(chat['chatAction'] === 'UNBLOCKED'){ @if(chat['lastMessageFrom'] == chat['chatId'] ){
          <span style="color: purple"></span>
          } @else{
          <span style="color: purple"></span>
          } } }  -->
          @else {
          <div class="last-message" style="max-width: 200px; text-overflow: ellipsis; height: 3.25rem">
            {{ chat["lastMessage"] ?? "" }} <ng-container *ngIf="chat.category?.name || chat.type?.name">({{ chat.category?.name ?? chat.type?.name }})</ng-container>
          </div>
          }
        </div>
      </div>

      <!-- Unread Count -->
      <div class="chat-right-side" *ngIf="chatMode == 'Main'">
        <div class="unread-count" *ngIf="chat['unreadCount']">
          <span>
            {{ chat["unreadCount"] }}
          </span>
        </div>
        <div class="about-product" *ngIf="chat['lastMesssageAboutProduct']">
          <img loading="lazy" *ngIf="chat['isBiz']" [src]="imageUrl + chat['lastMesssageAboutProduct']['foodImages'][0]['image']" />
          <img loading="lazy" *ngIf="!chat['isBiz']" [src]="imageUrl + chat['lastMesssageAboutProduct']['memberShopProductsImages'][0]['image']" />
          <span>{{ chat["lastMessageAboutProductDate"] | date : "dd-MM-yyyy" }}</span>
        </div>
      </div>
    </div>
  </div>
  }
</div>
